import { Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { PolicyTable } from '../../types/cancelAndModifyPolicies'
import useStyles from './styles/PoliciesActionRowMobile.styles'

interface PoliciesActionRowMobileProps {
  policiesData: PolicyTable
}
const PoliciesActionRowMobile: React.FC<PoliciesActionRowMobileProps> = ({
  policiesData
}) => {
  const classes = useStyles()
  const {
    deadline,
    deadlineTimeOffset,
    penaltyAmount,
    penaltyType,
    priority,
    policyType
  } = policiesData
  return (
    <div className={classes.root}>
      <div className={classes.tableRowRoot}>
        <div className={classes.tableRow}>
          <div>{`${getTranslate('Priority')}:`}</div>
          <div>
            <Typography variant="body1">{priority}</Typography>
          </div>
        </div>
        <div className={classes.tableRow}>
          <div>{`${getTranslate('Penalty Amount')}:`}</div>
          <div>
            <Typography variant="body1">{penaltyAmount}</Typography>
          </div>
        </div>
        <div className={classes.tableRow}>
          <div>{`${getTranslate('Penalty Type')}:`}</div>
          <div>
            <Typography variant="body1">{penaltyType}</Typography>
          </div>
        </div>
        <div className={classes.tableRow}>
          <div>{`${getTranslate('Deadline (hrs)')}:`}</div>
          <div>
            <Typography variant="body1">{deadline}</Typography>
          </div>
        </div>
        <div className={classes.tableRow}>
          <div>{`${getTranslate('Deadline Time Offset')}:`}</div>
          <div>
            <Typography variant="body1">{deadlineTimeOffset}</Typography>
          </div>
        </div>
        <div className={classes.tableRow}>
          <div>{`${getTranslate('Type')}:`}</div>
          <div>
            <Typography variant="body1">{policyType}</Typography>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PoliciesActionRowMobile
